var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1976d2",
    stroke: "#1976d2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: "35%",
    y1: "20%",
    x2: "50%",
    y2: "05%",
    strokeWidth: "7%"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "05%",
    y1: "50%",
    x2: "20%",
    y2: "35%",
    strokeWidth: "7%"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "80%",
    y1: "35%",
    x2: "95%",
    y2: "50%",
    strokeWidth: "7%"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "50%",
    y1: "05%",
    x2: "65%",
    y2: "20%",
    strokeWidth: "7%"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "65%",
    y1: "80%",
    x2: "50%",
    y2: "95%",
    strokeWidth: "7%"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "95%",
    y1: "50%",
    x2: "80%",
    y2: "65%",
    strokeWidth: "7%"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "20%",
    y1: "65%",
    x2: "05%",
    y2: "50%",
    strokeWidth: "7%"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "50%",
    y1: "95%",
    x2: "35%",
    y2: "80%",
    strokeWidth: "7%"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "05%",
    cy: "50%",
    r: "3.4%"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "50%",
    cy: "05%",
    r: "3.4%"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "95%",
    cy: "50%",
    r: "3.4%"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "50%",
    cy: "95%",
    r: "3.4%"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "35%",
    cy: "20%",
    r: "3.4%"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "80%",
    cy: "35%",
    r: "3.4%"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "65%",
    cy: "80%",
    r: "3.4%"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "20%",
    cy: "65%",
    r: "3.4%"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "20%",
    cy: "35%",
    r: "3.4%"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "65%",
    cy: "20%",
    r: "3.4%"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "80%",
    cy: "65%",
    r: "3.4%"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "35%",
    cy: "80%",
    r: "3.4%"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "30%",
    y1: "50%",
    x2: "50%",
    y2: "30%",
    strokeWidth: "7%"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "50%",
    y1: "30%",
    x2: "70%",
    y2: "50%",
    strokeWidth: "7%"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "70%",
    y1: "50%",
    x2: "50%",
    y2: "70%",
    strokeWidth: "7%"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "50%",
    y1: "70%",
    x2: "30%",
    y2: "50%",
    strokeWidth: "7%"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "30%",
    cy: "50%",
    r: "3.4%"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "50%",
    cy: "30%",
    r: "3.4%"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "70%",
    cy: "50%",
    r: "3.4%"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "50%",
    cy: "70%",
    r: "3.4%"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5a616d39fc73779986d8f611680f4f63.svg";
export { ForwardRef as ReactComponent };